import { ORG_NAME } from "app/appConfig";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import {
  getDateTime,
  getDisplayAddress,
  getImgLogo,
  getImgLogoTreamentPrint,
  getPrintPatientCode,
  getSystemConfig,
  TextView,
} from "app/common/LocalFunction";
import { toVietnamese } from "app/common/utils/VNUtils";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import React, { memo } from "react";

const TreatmentPrintContent = (props) => {
  const { componentRef, patient, listSelectedItem } = props;
  console.log("listSelectedItem", listSelectedItem);
  return (
    <PrintCommon ref={componentRef} marginPage="8mm" size="A4" hidden={false}>
      <header className="printHeader w-100 flex justify-between">
        <table className="table-layout-fixed">
          <tr>
            <td colSpan={4}>
              <div className="heading text-center mb-4">
                <h4>{ORG_NAME}</h4>
              </div>
            </td>
          </tr>
        </table>
      </header>

      <div className="cards-container flex-center" style={{ lineHeight: 2 }}>
        <div style={{ width: "80%" }}>
          <h3 className="text-center">PHIẾU CHỈ ĐỊNH DỊCH VỤ</h3>
          <div className="text-small text-center">
            {getDateTime(new Date())}
          </div>

          <h3>I. THÔNG TIN CÁ NHÂN</h3>

          <table className="info-table">
            <tbody>
              <tr>
                <td className="dotted-label">
                  <span>1. Tên khách hàng:</span>
                  <span className="dots">{patient?.displayName || ""}</span>
                </td>
                <td className="dotted-label">
                  <span>Mã khách hàng:</span>
                  <span className="dots">{getPrintPatientCode(patient, patient?.patientInfo)}</span>
                </td>
              </tr>

              <tr>
                <td className="dotted-label">
                  <span>3. Ngày sinh:</span>
                  <span className="dots">
                    {patient?.patientInfo?.birthDate
                      ? new Date(
                          patient.patientInfo.birthDate
                        ).toLocaleDateString("vi-VN")
                      : ""}
                  </span>
                </td>
                <td className="dotted-label">
                  <span>Nghề nghiệp:</span>
                  <span className="dots">
                    {patient?.profession?.name || ""}
                  </span>
                </td>
              </tr>

              <tr>
                <td className="dotted-label">
                  <span>4. Giới tính:</span>
                  <span className="dots">
                    {patient?.gender === "F" ? "Nữ" : "Nam"}
                  </span>
                </td>
                <td className="dotted-label full-width">
                  <span>Nguồn:</span>
                  <span className="dots">
                    {patient?.currentPatientSource?.name || ""}
                  </span>
                </td>
              </tr>

              <tr>
                <td className="dotted-label full-width" colSpan="2">
                  <span>5. Địa chỉ:</span>
                  <span className="dots">{getDisplayAddress(patient)}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <h3>II. THÔNG TIN SẢN PHẨM</h3>
          <div className="table-responsive">
            <table className="table-collapse">
              <thead>
                <tr>
                  <th>STT</th>
                  <th>TÊN DỊCH VỤ</th>
                  <th>KẾT QUẢ</th>
                  <th>NGƯỜI CHỈ ĐỊNH</th>
                  <th>NGƯỜI THỰC HIỆN</th>
                  <th>CƠ SỞ</th>
                  <th>PHÒNG THỰC HIỆN</th>
                </tr>
              </thead>
              <tbody>
                {listSelectedItem?.map((item, index) => {
                  const report = item?.diagnosticReport;
                  console.log("🚀 ~ listSelectedItem:", listSelectedItem)
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <span>{item?.service?.code}</span>{" "}
                        <span>
                          {item?.service?.tradeName || item?.service?.name}
                        </span>
                      </td>
                      <td>
                        {report ? (
                          <div>
                            <div>
                              <strong>Kết luận:</strong>{" "}
                              {report?.conclude || "Không có"}
                            </div>
                            <div>
                              <strong>Ghi chú:</strong>{" "}
                              {report?.note || "Không có"}
                            </div>
                          </div>
                        ) : (
                          <>
                            <i style={{ color: "#999" }}>Chưa có kết quả</i>
                          </>
                        )}
                      </td>

                      <td>{item?.assigner?.staffName}</td>
                      <td>
                        {item?.encounterParticipants?.map((el, ind) => (
                          <div>
                            <span>
                              {el?.staff?.staffName}
                              {": "}
                            </span>
                            <span
                              style={{
                                fontWeight: "400",
                                fontSize: "12px",
                                fontStyle: "italic",
                              }}
                            >
                              {el?.position?.name}
                            </span>
                          </div>
                        ))}
                      </td>
                      <td>{item?.department?.name}</td>
                      <td>{item?.room?.name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div style={{textAlign:"center", fontSize:'18px', marginTop:"10px"}}>
                <span style={{fontWeight:"bold"}}>Chữ ký khách hàng</span>
                <div style={{height:"150px"}}>

                </div>
          </div>
        </div>
      </div>
    </PrintCommon>
  );
};

export default memo(observer(TreatmentPrintContent));
